import { slugResolver } from '../../art/raster';
import { flatCollectible } from '../../art/flat-collectible';

/**
 * The PET content-plugin (ADR-0108 · ADR-0114) — a flat collectible: its painted sprite floats in its tile
 * (`sprite` fit = `meet`), and it has no staged backdrop (a pet sits BESIDE the hero, positioned by HeroStage
 * via the tile, not as a stage layer). The `import.meta.glob` literal stays here (Vite resolves it at build);
 * each art file's stem IS its pet slug. WEB-ONLY (the art subpath), never imported by the API/Node.
 */
const petAssetFor = slugResolver(
  import.meta.glob('./art/*.webp', { eager: true, query: '?url', import: 'default' }),
);

export const petPlugin = flatCollectible({
  kind: 'pet',
  assetFor: petAssetFor,
  tileFit: 'sprite',
});
